import { DiffEditor, DiffEditorProps, Editor, EditorProps, Theme as EditorTheme } from '@monaco-editor/react';
import * as Monaco from 'monaco-editor';
import z from 'zod/v4';

import { Spinner, ThemeType, useThemeContext } from '@ingrid/luterkort-react';

import {
  useBookingRuleOutputSchema,
  useShipmentSchema,
} from '~src/pages/settings/booking-rule-configurator/edit/hooks';

export type { OnMount, OnValidate } from '@monaco-editor/react';

export type CodeEditorProps = Omit<EditorProps, 'theme' | 'height' | 'loading' | 'beforeMount'>;
export type CodeDiffEditorProps = Omit<DiffEditorProps, 'theme' | 'height' | 'loading'>;

const ThemeMap: Record<ThemeType, EditorTheme> = {
  dark: 'vs-dark',
  light: 'light',
};

export function CodeEditor(props: CodeEditorProps) {
  const { theme } = useThemeContext();

  const ruleSchema = useBookingRuleOutputSchema();
  const shipmentSchema = useShipmentSchema();

  function handleBeforeMount(monaco: typeof Monaco) {
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      schemaValidation: 'error',
      schemas: [
        {
          uri: 'http://myserver/shipment.json',
          schema: z.toJSONSchema(shipmentSchema),
          fileMatch: ['shipment.json'],
        },
        {
          uri: 'http://myserver/rule.json',
          schema: z.toJSONSchema(ruleSchema),
          fileMatch: ['rule.json'],
        },
      ],
      validate: true,
    });
  }

  return (
    <Editor beforeMount={handleBeforeMount} theme={ThemeMap[theme]} height="100%" loading={<Spinner />} {...props} />
  );
}

export function CodeDiffEditor(props: DiffEditorProps) {
  const { theme } = useThemeContext();

  return <DiffEditor theme={ThemeMap[theme]} height="100%" loading={<Spinner />} {...props} />;
}
